<template>

<app-modalData :init = "metaData"  @f="f($event)"  v-if="metaData">
<div slot="icons">

<v-tooltip v-if="likes.selectedCat.status == '1'"   allow-overflow open-delay="300" left max-width="250">
<v-icon color="#FF8F18" slot="activator" @click="fastAutoStarter()" >mdi-flash</v-icon>
<span>Кликните если хотите остановить автообновление</span>
</v-tooltip>

<v-tooltip v-if="likes.selectedCat.status == '0'"   allow-overflow open-delay="300" left max-width="250">
<v-icon color="#808080" slot="activator" @click="fastAutoStarter()" >mdi-flash</v-icon>
<span>Кликните если хотите запустить автообновление</span>
</v-tooltip>


<v-tooltip allow-overflow open-delay="300" left max-width="250">
<v-icon slot="activator" @click="updaterMembers(likes.checkList[0])" >mdi-update</v-icon>
<span> Обновить список выбранных  ({{this.likes.checkList.length}}) элементов </span>
</v-tooltip>


<v-tooltip  allow-overflow open-delay="300" left max-width="250">
<v-icon  slot="activator" medium @click="closeUpdater()">mdi-close</v-icon>
<span> Закрыть обновление лайков </span>
</v-tooltip>

</div>


<span slot="status">
<span v-if="updating.inProccess"  style="font-size:1.3em; margin:5px;color:#727272">  ID: {{updating.groupName}}  {{updating.updatingPercent.toFixed() }} %  </span>
</span>

<div slot="starter"   class="text-xs-center" v-if="starter">
<p style="padding:15px;color:gray">
Данная возможность позволяет получить список новых лайков
в выбранных вами сообществаx
</p>
<v-btn style="text-transform:none" dark  @click="starter = false;updaterMembers(likes.checkList[0])" color="#273C51"><v-icon left> mdi-update</v-icon> Обновить выбранные элементы</v-btn>
</div>

<div slot="operations">

 тут операции

</div>


<div slot="additinalLayout" style="margin:20px;  ">
<v-layout wrap align-center justify-center>
<div style="max-width:350px; min-width:350px" v-for="  item in allForUpdate">
<v-layout style="margin-left:15px;margin-bottom:35px">
<img  style="border-radius:50%"  width="100" height=100 :src="item.photo_100"></img>
<div style="margin-left:15px">
<a target="_blank" :href="item.url">  {{item.name}}  </a>
<p> Участники:  {{item.members_count}}      </p>
<v-btn style="text-transform:none;margin-left:-7px" @click="deleteSelectedItem(item)" small flat color="#273C51"> Убрать из списка</v-btn>
</div>
</v-layout>
</div>
</v-layout>
</div>

</app-modalData>

</template>

<script>
import axios from 'axios'
export default {
props: ['modals', 'groups', 'likes'],
data: function(){
  return {
   saveInfoOfSourceNewIn: true, // запоминать страницы и указывать куда именно подписались
   saveInfoOfSourceNewOut: false, // Запомнить страницы и указать от куда отписались
   turbo: false,   // использование параллельных запросов на обновление в молнии
   allForUpdate : [],   // читсто что бы посмотреть что выбрал только что если короткая память







starter: true,
  fastAutoParams: false,
  autoparams: false,


  updating: {
    groupName: 'updating',
    intervalSet: {
      sec: 59,
      min: 9,
      hours: 0,
    },
    inProccess : false,
    interval: 7,
    timer: 35,
    auto: false,
    currentPage: 0,
    updatingPercent: 0,
  },


modalData:{
sb: { snackbar: false, color: 'success', text: ''},
f: "",
selectedItem: "followers",
header:{
text:"",
icon:"mdi-database",
icons:[]
},
bar: {
items:[
{
itemName: 'followers',
text:'Новые лайки',
f: null,
},
],
status: ""
},
content:{
type:'pages',
items:{
followers:{
foundData: {},
meneger:{}
},
},
},
operations:{}
},


contentMenegment: {
marginTop: '0px',
snackbarAbsoute: true,
items: {
selector: {active:true},
copy: {active:true},
export: {active:true},
update: {active:false},
delete: {active:false},
autoExport: {active:false},
autoExportTxt: {active:true},
},
contentInfo: {
type: 'pages',
},
autoExport: {
saveSourceInfo: false,
isActive: false,
tasksList:[],
},
txtAutoExport : {
pattern: {},
isActive: false,
},
},

}
},


methods: {

f(fName){
eval('this.'+fName+'()')
},



updaterMembers(groupId){
this.starter = false
this.updating.inProccess = true
this.updating.groupName = groupId


axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/post_likes/src_check.php', {
method: 'POST',
data: {src_id: groupId, src_type:this.likes.selectedCat.params.source_type}
}).then(response => {
//++this.updating.currentGroup
if( response.data  === false){
this.modalData.sb.text = 'ошибка обновления, что то пошло не так ... скорее всего лимиты на обновления или все аккаунты блокнуты'
this.modalData.sb.color = 'red'
this.modalData.sb.snackbar = true
}


// offset current group
if(this.updating.currentGroup <= (this.likes.checkList.length - 1)){
this.updaterMembers(this.likes.checkList[++this.updating.currentGroup])
if(this.updating.currentGroup <= this.likes.checkList.length){this.updating.updatingPercent = this.updating.currentGroup / this.likes.checkList.length  * 100}

} else {
this.updating.currentGroup  = 0
this.updating.inProccess = false
}

if(typeof response.data.in !== 'undefined' ) {
this.likes.checker.foundData.foundIds = this.likes.checker.foundData.foundIds.concat(response.data.in)
console.log(this.likes.checker.foundData)
}

}).catch(
()=>{setTimeout(()=>{
this.updaterMembers1(groupId)}, 3000)
})

},


reUpdater(){
this.updaterMembers(this.likes.checkList[this.updating.currentGroup])
},


closeUpdater(){
this.likes.modals.checkGroup = false
this.likes.selector = false
this.updating.auto = false
this.fastUpdating.auto = false
},

infoOfSelecteted(){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/get_description.php', {
       method: 'POST',
       data: {
         dataString: this.likes.checkList.join(","),
         dataType: 'groups',
         addInfo: false,
       }
     }).then(response => {
       this.allForUpdate = response.data
 })


},

deleteSelectedItem(item){
  if(this.likes.checkList.length > 1){
  this.likes.checkList.splice( this.likes.checkList.indexOf(item.id), 1 )
} else {
  this.modalData.sb.snackbar = true
  this.modalData.sb.color = 'red'
  this.modalData.sb.text = 'Нельзя удалить все сообщества из списка, иначе просто нечего будет отслеживать '
}
},


},

computed: {

metaData(){
if(this.likes.modals.checkGroup){
this.starter = true
this.updating.currentGroup  = 0

this.modalData.header.text = 'Новые лайки постов'

this.modalData.content.items.followers.foundData = this.likes.checker.foundData
this.modalData.content.items.followers.meneger =  this.contentMenegment
this.infoOfSelecteted()

return this.modalData
} else return false
},



},


}
</script>

<style  >

</style>
